import { render, staticRenderFns } from "./BenefitsMoment.vue?vue&type=template&id=562e8b67&"
import script from "./BenefitsMoment.vue?vue&type=script&lang=js&"
export * from "./BenefitsMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports